// In case you are wondering we're wrappin DateRangeFilter so we can mock it in tests.
import { DateRangeFilter } from 'spoton-lib';

export function DateRangePicker(props: any) {
  return <DateRangeFilter {...props}></DateRangeFilter>;
}
